export const DEFAULT_ICON_NAME = 'arrow-narrow-right'